import { useState } from "react";
import { Avatar } from "./avatar";

interface ValidAccountSelectOption {
  avatar_url: string;
  email: string | null;
  kind: "user" | "organization";
  username: string;
}

export type AccountSelectOption = ValidAccountSelectOption & {
  avatar_url: string | null;
  kind: "user" | "organization" | null;
  name: string | null;
};

export default function AccountSelect({
  accounts,
  id,
  name,
  value,
}: {
  accounts: AccountSelectOption[];
  id: string;
  name: string;
  value: string;
}) {
  const validAccounts = accounts.filter(
    (account) => account.username && account.kind && account.avatar_url
  ) as ValidAccountSelectOption[];

  const [currentAccount, setCurrentAccount] = useState(
    validAccounts.find((account) => account.username === value)
  );

  if (validAccounts.length === 0) {
    return (
      <select
        className="form-select w-full !pl-12 font-semibold"
        name={name}
        id={id}
      >
        <option value="" selected>
          {" "}
        </option>
      </select>
    );
  }

  return (
    <div>
      <div className="relative">
        {currentAccount?.avatar_url && (
          <div className="absolute left-0 top-0 bottom-0 flex items-center justify-center pl-2 pointer-events-none">
            <Avatar
              className="w-8 h-8"
              avatar={{
                kind: currentAccount.kind,
                url: currentAccount.avatar_url,
              }}
            />
          </div>
        )}
        <select
          value={currentAccount?.username ?? ""}
          onChange={(e) => {
            const account = validAccounts.find(
              (account) => account.username === e.target.value
            );
            setCurrentAccount(account);
          }}
          className="form-select w-full !pl-12 font-semibold"
          name={name}
          id={id}
        >
          {validAccounts.map((account) => (
            <option
              key={account.username}
              value={account.username}
              selected={account.username === value}
            >
              {account.username}
            </option>
          ))}
        </select>
      </div>
      <p className="mt-1 text-r8-sm text-r8-gray-11">
        Email address: {currentAccount?.email || "Unknown"}
      </p>
    </div>
  );
}
